// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";

var header_brand = "smartshift";

var header_source = "website";

function createHeader(web_tracking_id) {
  return {
          brand: header_brand,
          source: header_source,
          "client-request-uuid": web_tracking_id
        };
}

function createAuthenticatedHeaders(web_tracking_id, auth_token, mobile) {
  return {
          brand: header_brand,
          source: header_source,
          "client-request-uuid": web_tracking_id,
          mobile: mobile,
          "auth-token": auth_token,
          country: "in"
        };
}

function countOfLiveOrder(history) {
  if (typeof history === "number" || history.TAG !== /* Live */1) {
    return 0;
  } else {
    return history._0.length;
  }
}

function orderCrn(history, index) {
  if (typeof history === "number") {
    return "";
  }
  if (history.TAG !== /* Live */1) {
    return "";
  }
  var orders = history._0;
  if (orders.length > 0) {
    return Caml_array.get(orders, index).order_crn;
  } else {
    return "";
  }
}

function isCourierOrder(history, index) {
  if (typeof history === "number") {
    return false;
  }
  if (history.TAG !== /* Live */1) {
    return false;
  }
  var orders = history._0;
  if (orders.length > 0) {
    return Caml_array.get(orders, index)._type === /* Courier */3;
  } else {
    return false;
  }
}

var default_title = "Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!";

var default_desc = "Porter offers commercial vehicles & bike for delivery services. We offer complete logistics solutions including Packers & Movers and Outstation services. Book to enjoy superfast deliveries.";

var default_image_src = "https://nest-platform-assets.porter.in/header_logo_f22422636f.svg";

var default_image_alt = "Porter | Mini trucks & bikes for delivery | Packers & Movers | Book and transport easily!";

export {
  header_brand ,
  header_source ,
  default_title ,
  default_desc ,
  default_image_src ,
  default_image_alt ,
  createHeader ,
  createAuthenticatedHeaders ,
  countOfLiveOrder ,
  orderCrn ,
  isCourierOrder ,
}
/* No side effect */
